import { Catalog } from '@df/catalog/catalog.interfaces';
import { Model } from '@df/catalog/model';

/**
 * Customer attribute model representing magento customer attributes
 */
export class CustomerAttribute extends Model<Catalog.ICustomerAttributeData, string> {
    static override type = 'customerAttribute';

    get options(): Catalog.ICustomerAttributeOption[] {
        return this.data?.options || [];
    }
}
